module.exports = __webpack_public_path__ + "static/media/whipPunch.1c3ce15e.mp3";